import React, { useState, useRef } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from "common";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Modal, Grid, Typography } from "@mui/material";
import Button from "components/CustomButtons/Button.js";
import AlertDialog from "../components/AlertDialog";
import CircularProgress from "@mui/material/CircularProgress";
import { colors } from "../components/Theme/WebTheme";
import moment from "moment/min/moment-with-locales";
import IconButton from '@mui/material/IconButton';
import PhotoIcon from '@mui/icons-material/Photo'; // Ícone de foto padrão do Material-UI


const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  submit3: {
    width: "100%",
    borderRadius: 3,
    marginTop: 2,
    padding: 4,
  },
  paper: {
    width: 500,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: 15,
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default function Advertising() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector((state) => state.settingsdata.settings);
  const advertising = useSelector((state) => state.advertising);
  const classes = useStyles();
  const { editAdvertising } = api;
  const dispatch = useDispatch();
  const rootRef = useRef(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [profileModal, setProfileModal] = useState(false);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [imageSelected, setImageSelected] = useState();
  const [loading, setLoading] = useState(false);


  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  const UpdateImg = async () => {
    setLoading(true);
    await dispatch(editAdvertising(selectedRow, "UpdateImage", imageSelected));


    setProfileModal(false);
    setSelectedRow(null);
    setImageSelected(null);
    setLoading(false);
  };


  const columns = [
    {
      title: t("createdAt"),
      field: "createdAt",
      editable: "never",
      defaultSort: "desc",
      render: (rowData) =>
        moment(rowData.createdAt).format("lll"),
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("active_status"),
      field: "active",
      type: "boolean",
    },
    // {
    //   title: t("name"),
    //   field: "name",
    //   type: "string",
    // },
    {
      title: t("link"),
      field: "link",
      type: "string",
    },
    {
      title: "imagem",
      field: "photoUrl",
      editable: "never",
      render: (rowData) =>
        <Button
          style={{
            height: '6em',
            width: '10em',
            padding: 0,
          }}
          disabled={profileModal}
          onClick={() => {
            setProfileModal(true);
          }}
        >
          {rowData.photoUrl ? (
            <img
              alt=""
              src={rowData.photoUrl}
              style={{
                height: '100%',
                width: '100%',
                objectFit: 'cover',
              }}
            />
          ) : (
            <IconButton
              style={{
                height: '100%',
                width: '100%',
              }}
              disabled={profileModal}
              onClick={() => {
                setProfileModal(true);
              }}
            >
              <PhotoIcon style={{ fontSize: 48 }} />
            </IconButton>
          )}
        </Button>
    },
  ];


  return advertising.loading ? (
    <CircularLoading />
  ) : (
    <div ref={rootRef}>
      <MaterialTable
        title={t("advertising")}
        columns={columns}
        style={{
          direction: isRTL === "rtl" ? "rtl" : "ltr",
          borderRadius: "8px",
          boxShadow: "4px 4px 6px #9E9E9E",
        }}
        data={advertising.date}
        onRowClick={(evt, selectedRow) =>
          setSelectedRow(selectedRow)
        }
        options={{
          exportButton: true,
          rowStyle: (rowData) => {
            return {
              backgroundColor:
                selectedRow === rowData.tableData.id
                  ? "rgba(0, 0, 0, 0.5)"
                  :
                  "#EEE"
            };
          },
          editable: {
            backgroundColor: colors.Header_Text,
            fontSize: "0.8em",
            fontWeight: "bold ",
            fontFamily: 'Lucida Console", "Courier New", monospace',
          },
          headerStyle: {
            position: "sticky",
            top: "0px",
            backgroundColor: colors.Header_Text_back,
            color: "#fff",
            fontSize: "0.8em",
            fontWeight: "bold ",
            fontFamily: 'Lucida Console", "Courier New", monospace',
          },
        }}
        localization={{
          body: {
            addTooltip: t("add"),
            deleteTooltip: t("delete"),
            editTooltip: t("edit"),
            emptyDataSourceMessage: t("blank_message"),
            editRow: {
              deleteText: t("delete_message"),
              cancelTooltip: t("cancel"),
              saveTooltip: t("save"),
            },
          },
          toolbar: {
            searchPlaceholder: t("search"),
            exportTitle: t("export"),
          },
          header: {
            actions: t("actions"),
          },
          pagination: {
            labelDisplayedRows: "{from}-{to} " + t("of") + " {count}",
            firstTooltip: t("first_page_tooltip"),
            previousTooltip: t("previous_page_tooltip"),
            nextTooltip: t("next_page_tooltip"),
            lastTooltip: t("last_page_tooltip"),
          },
        }}
        editable={{
          onRowAdd: (newData) =>
            settings.AllowCriticalEditsAdmin
              ? new Promise((resolve, reject) => {
                setTimeout(() => {

                  newData["createdAt"] = new Date().getTime();
                  dispatch(editAdvertising(newData, "Add"));


                  setSelectedRow(null)
                  resolve();
                }, 600);
              })
              : new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  alert(t("demo_mode"));
                }, 600);
              })
          ,
          onRowUpdate: (newData, oldData) =>
            settings.AllowCriticalEditsAdmin
              ? new Promise((resolve) => {
                setTimeout(() => {
                  delete newData.tableData;
                  dispatch(editAdvertising(newData, "Update"));
                  resolve();
                }, 600);
              })
              : new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  alert(t("demo_mode"));
                }, 600);
              }),
          onRowDelete: (oldData) =>
            settings.AllowCriticalEditsAdmin
              ? new Promise((resolve, reject) => {
                setTimeout(() => {
                  dispatch(editAdvertising(oldData, "Delete"));
                }, 600);
                resolve()
              })
              : new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  alert(t("demo_mode"));
                }, 600);
              }),
        }}

      />
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={profileModal}
        onClose={() => {
          setProfileModal(false)
          setSelectedRow(null)
          setImageSelected(null)
        }}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid
          container
          spacing={1}
          className={classes.paper}
          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography component="h1" variant="h6">
              {t("image")}
              <input
                type="file"
                style={{ marginLeft: 10 }}
                name={t("image")}
                onChange={(event) => {
                  setImageSelected(event.target.files[0]);
                }}
              />
            </Typography>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            {imageSelected ? (
              <img
                alt="not fount"
                src={URL.createObjectURL(imageSelected)}
                style={{ height: '15em', marginTop: 10 }}
              />
            ) : (
              <img
                alt="not fount"
                src={selectedRow ? selectedRow?.photoUrl : imageSelected}
                style={{ height: '15em', marginTop: 10 }}
              />
            )}
            <br />
          </Grid>



          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
          >
            {loading ? (
              <Grid
                container
                spacing={0}
                alignItems="center"
                justify="center"
                style={{ minHeight: "5vh" }}
              >
                <CircularProgress />
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
              >
                <Button
                  onClick={() => {
                    setProfileModal(false);
                  }}
                  variant="contained"
                  color="danger"
                >
                  {t("cancel")}
                </Button>
                <Button
                  onClick={UpdateImg}
                  variant="contained"
                  color="secondaryButton"
                  style={{ marginLeft: 10 }}
                >
                  {t("save")}
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Modal>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </div>
  );
}
